import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;
let listeners = new Set();

export function usePublicConfig() {
  const [cfg, setCfg] = useState(cached);

  useEffect(() => {
    let mounted = true;
    if (!cached) {
      api
        .get("/public-config")
        .then((r) => {
          cached = r.data;
          listeners.forEach((cb) => cb(cached));
          if (mounted) setCfg(cached);
        })
        .catch(() => {
          if (mounted) setCfg({});
        });
    }
    const cb = (c) => mounted && setCfg(c);
    listeners.add(cb);
    return () => {
      mounted = false;
      listeners.delete(cb);
    };
  }, []);

  return cfg || {};
}

export function publicConfigUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return `${backend}${path}`;
}
